import { StoreFormattedDate } from "arkh";
import { DateTime } from "luxon";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { CalendarOverviewEventItemDateTime_event$key } from "./__generated__/CalendarOverviewEventItemDateTime_event.graphql";

export function CalendarOverviewEventItemDateTime(props: {
  event: CalendarOverviewEventItemDateTime_event$key;
}) {
  const event = useFragment(
    graphql`
      fragment CalendarOverviewEventItemDateTime_event on CalendarEvent {
        startAtDateAndTime: startAt {
          isoString
          ...StoreFormattedDate @arguments(style: DEFAULT)
        }
        endAtDateAndTime: endAt {
          isoString
          ...StoreFormattedDate @arguments(style: DEFAULT)
        }
        startAtWeekdayAndDate: startAt {
          ...StoreFormattedDate @arguments(style: WEEKDAY_AND_DATE)
        }
        endAtWeekdayAndDate: endAt {
          ...StoreFormattedDate @arguments(style: WEEKDAY_AND_DATE)
        }
        endAtTime: endAt {
          ...StoreFormattedDate @arguments(style: TIME_ONLY)
        }
        isAllDayEvent
      }
    `,
    props.event
  );

  const isSameDay = DateTime.fromISO(
    event.startAtDateAndTime.isoString
  ).hasSame(DateTime.fromISO(event.endAtDateAndTime.isoString), "day");

  if (event.isAllDayEvent) {
    if (isSameDay) {
      return <StoreFormattedDate date={event.startAtWeekdayAndDate} />;
    }
    return (
      <>
        {<StoreFormattedDate date={event.startAtWeekdayAndDate} />}
        {" - "}
        {<StoreFormattedDate date={event.endAtWeekdayAndDate} />}
      </>
    );
  }

  if (isSameDay) {
    return (
      <>
        {<StoreFormattedDate date={event.startAtDateAndTime} />}
        {" - "}
        {<StoreFormattedDate date={event.endAtTime} />}
      </>
    );
  }

  return (
    <>
      <StoreFormattedDate date={event.startAtDateAndTime} />
      {" - "}
      <StoreFormattedDate date={event.endAtDateAndTime} />
    </>
  );
}
